import { createApp } from "vue";
import {
  useAuth,
  createHttpClient,
  getStoredTenantConfig,
  type AuthConfig,
} from "@inbim/platform-core";
import App from "./app/App.vue";
import router from "./app/router";
import { API_KEY } from "./app/api";
import "./app/index.css";

/**
 * Bootstrap ramificado: as rotas públicas rodam antes de qualquer tenant ser
 * conhecido. O Keycloak só é inicializado quando a descoberta por e-mail já
 * persistiu a configuração do realm.
 */
async function bootstrap(): Promise<void> {
  const app = createApp(App);

  const tenantConfig = getStoredTenantConfig();
  if (tenantConfig) {
    const authConfig: AuthConfig = {
      keycloakUrl: tenantConfig.keycloakUrl,
      realm: tenantConfig.realm,
      // Os realms existentes já provisionam app-laudo-frontend como client
      // público PKCE. Produção pode fornecer um client dedicado por variável.
      clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || "app-laudo-frontend",
    };
    const api = createHttpClient({
      baseURL: import.meta.env.VITE_API_BASE_URL || "",
      tenantSlug: tenantConfig.slug,
    });
    const { init } = useAuth();
    await init(authConfig, api.get.bind(api));
    app.provide(API_KEY, api);
  }

  app.use(router);
  app.mount("#app");
}

bootstrap();
